// extracted by mini-css-extract-plugin
export default {"container":"products_container__F7bek"};